export default __webpack_public_path__ + "static/media/hight.31ef6c11.png";